import { Box, Input, Text, FormLabel, Button } from "@chakra-ui/react";

import { useFormik } from "formik";
import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";

const LoginForm = ({ forgotPassword }) => {
  const toast = useToast();

  const [loading, setLoading] = useState(false);

  const validate = (values) => {
    let errors = {};
    if (!values.email) {
      errors.email = "Email Address is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      setLoading(true);

      let data = {
        email: values.email,
      };

      forgotPassword(data)
        .then((res) => {
          setLoading(false);
          toast({
            position: "bottom-right",
            description: "email verification sent",
            status: "success",
            title: "Success",
            duration: 9000,
            isClosable: true,
          });
          resetForm({ values: "" });
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && err.response.data.status === false) {
            // not authorized!
            return toast({
              title: "Error",
              description: "Email address or password is incorrect",
              status: "error",
              duration: 9000,
              isClosable: true,
            });
          }
          // some error occurred
          //   return toast({
          //     title: "Error",
          //     description: "Something went wrong, please try again",
          //     status: "error",
          //     duration: 9000,
          //     isClosable: true,
          //   });
        });
    },
  });

  return (
    <>
      <Box as="form" px={8} onSubmit={formik.handleSubmit}>
        <Text color="#00A2E8" mb={2}>
          Forgot Password?
        </Text>
        <Text color="#000000" fontSize="18" my={3}>
          A link to reset your password will be sent to your registered email.
        </Text>
        <Box>
          <FormLabel htmlFor="email">Email Address</FormLabel>
          <Input
            id="email"
            type="email"
            name="email"
            onChange={formik.handleChange}
            value={formik.values.email}
          />

          {formik.errors.email ? (
            <Text color="red.500" fontSize="sm" mt={3}>
              {formik.errors.email}
            </Text>
          ) : null}
        </Box>

        <Button
          mt={8}
          isFullWidth
          colorScheme="light"
          bg="#00A2E8"
          isLoading={loading}
          type="submit"
        >
          Submit
        </Button>
      </Box>
    </>
  );
};

export default LoginForm;
